export enum UserRole {
  SVCUSR = 'SVCUSR',
  SVCUSR_SPR = 'SVCUSR_SPR',
  AGENT = 'AGENT',
  AGENT_SPR = 'AGENT_SPR',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  PLAT_ADMIN = 'PLAT_ADMIN',
  OWNER = 'OWNER',
  OWNER_SPR = 'OWNER_SPR',
  SUPP = 'SUPP',
  SUPP_SPR = 'SUPP_SPR',
}

export enum FullUserRole {
  SVCUSR = 'common:people:service_user',
  SVCUSR_SPR = 'common:people:super_service_user',
  AGENT = 'common:people:agent',
  AGENT_SPR = 'common:people:super_agent',
  CLIENT_ADMIN = 'common:people:client_admin',
  PLAT_ADMIN = 'common:people:platform_admin',
  OWNER = 'common:people:owner',
  OWNER_SPR = 'common:people:super_owner',
  SUPP = 'common:people:supplier',
  SUPP_SPR = 'common:people:super_supplier',
}

export const ManagerRoles = [
  UserRole.AGENT,
  UserRole.AGENT_SPR,
  UserRole.CLIENT_ADMIN,
  UserRole.PLAT_ADMIN,
  UserRole.OWNER,
  UserRole.OWNER_SPR,
];

export const AgentRoles = [UserRole.AGENT, UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN];

export const AllRoles = [UserRole.SVCUSR, UserRole.SVCUSR_SPR, ...ManagerRoles, UserRole.SUPP, UserRole.SUPP_SPR];
